import { useTranslation } from 'react-i18next';
import type { NavGroupNode, NavCtx } from '../nav-config';
import { NavLeaf } from '../NavLeaf/NavLeaf';
import styles from './styles.module.css';

type INavGroupProps = {
  group: NavGroupNode;
  ctx: NavCtx;
  expanded: boolean;
  active: boolean;
  collapsed: boolean;
  onToggle: () => void;
};

function Chevron({ open }: { open: boolean }) {
  return (
    <svg
      className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

export function NavGroup({ group, ctx, expanded, active, collapsed, onToggle }: INavGroupProps) {
  const { t } = useTranslation();
  const label = t(group.labelKey);
  const panelId = `nav-panel-${group.id}`;

  return (
    <div className={`${styles.group} ${collapsed ? styles.groupCollapsed : ''}`}>
      <button
        type="button"
        className={`${styles.header} ${active ? styles.headerActive : ''} ${expanded && !collapsed ? styles.headerExpanded : ''}`}
        onClick={onToggle}
        aria-expanded={expanded}
        aria-controls={panelId}
        title={collapsed ? label : undefined}
      >
        <span className={styles.icon}>{group.icon}</span>
        {!collapsed && <span className={styles.label}>{label}</span>}
        {!collapsed && <Chevron open={expanded} />}
      </button>
      {!collapsed && expanded && (
        <div id={panelId} className={styles.children}>
          <div className={styles.childrenInner}>
            {group.children.map((leaf) => (
              <NavLeaf key={leaf.id} leaf={leaf} ctx={ctx} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
